import { render, staticRenderFns } from "./GarbageDisposalDistrict.vue?vue&type=template&id=ddbfa1a4&"
import script from "./GarbageDisposalDistrict.vue?vue&type=script&lang=js&"
export * from "./GarbageDisposalDistrict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports